import { sessionApi } from '@/api/sessionApi'

export type SessionUser = {
  userName?: string
  accessLevel?: string
  email?: string
  _id?: string
  [key: string]: unknown
}

export function getAccessToken(): string | null {
  return localStorage.getItem('accessToken')
}

export function clearSessionStorage() {
  localStorage.removeItem('accessToken')
  localStorage.removeItem('userDetails')
}

export async function fetchClientIp() {
  try {
    const res = await sessionApi.getIp()
    const ip = (res.data as { ip?: string })?.ip
    if (ip) localStorage.setItem('clientIP', ip)
    return ip
  } catch {
    return null
  }
}

export async function getUserProfile(): Promise<SessionUser | null> {
  try {
    const res = await sessionApi.getUserByAccessToken({})
    return (res.data as SessionUser) ?? null
  } catch {
    return null
  }
}

export function capitalize(s: string) {
  if (!s) return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}
